
export interface IHoldRequest {
   
    HoldItemID: number;
    CreditCardID: number;
    LicenseKey: string;
    Initials: string;
}

export class HoldRequest implements IHoldRequest {

    HoldItemID: number;
    CreditCardID: number;
    LicenseKey: string;
    Initials: string;
}

